import { getToken } from "@/services/api/auth.js";
import { limparSessao } from "@/services/limparSessao.js";
import { sessaoFoiRevogada } from "@/services/sso.js";

export async function apiRequest({ client = {}, orderBy= [], method = "", url, params = {}, body = undefined, sendToken = true, headers = {}}){
    try {
        let orderByStr = '';
        if (orderBy.length) {
            orderByStr = 'orderBy=' + orderBy
                .map(s => `${s.key} ${s.desc ? 'desc' : 'asc'}`)
                .join('|')
        }
        if (sendToken) {
            const token = getToken();
            headers.Authorization = `Bearer ${token}`;
        }

        let finalUrl = url;
        if (orderByStr) {
            finalUrl += (url.includes('?') ? '&' : '?') + orderByStr;
        }

        const response = await client.request({
            method,
            url: finalUrl,
            params,
            data: body,
            headers,
        });

        return response.data || response;
    } catch (error) {
        if (sessaoFoiRevogada(error)) {
            // Alguem saiu da plataforma em outra aplicacao. Nao adianta tentar
            // renovar: o token e todos os irmaos dele morreram junto.
            limparSessao();
            window.location.assign('/');

            // A pagina esta indo embora: nao vale resolver nem rejeitar, so
            // evitar que a tela mostre erro no meio do caminho.
            return new Promise(() => {});
        }

        return Promise.reject(error);
    }
}
